/* tslint:disable */
/* eslint-disable */

/**
 * The parent resource a comment is attached to.
 */
export enum CommentParentType {
  Client = 'client',
  EndCustomer = 'end_customer',
  Invoice = 'invoice'
}
